export enum JwtGameAvalability {
  OFFLINE = "offline",
  ONLINE = "online",
}
